import * as React from 'react';

import Error500 from 'src/components/500/500';
import Error410 from 'src/components/410/410';
import Error404 from 'src/components/404/404';
import 'src/components/app.global.css';
import styles from 'src/components/referral-external/app.css';


export default function ReferralErrorComponent(props: {
  status?: number;
  agency_link?: string;
  buttonColor?: string;
}) {
  const {status, agency_link, buttonColor} = props;

  if (status === 410) {
    return (
      <Error410
        buttonText="Refer Now"
        redirectLink={agency_link}
        buttonColor={buttonColor}
      />
    );
  }
  if (status === 404) {
    return <Error404 />;
  }
  return (
    <div className={styles.body}>
      <Error500 />
    </div>
  );
}
